import { Box, useMediaQuery } from "@chakra-ui/react";
import Select, { StylesConfig } from "react-select";
import { InputLabel } from "components";
import { DropdownIcon } from "./DropdownIcon";

interface IReactSelectProps {
  options: {
    value: string;
    label: string;
  }[];
  placeholder: string;
  label?: string;
  onChange: any;
  name?: string;
  handleMenuScrollToBottom?: any;
  onInputChange: (e: string) => void;
  isLoading?: boolean;
  defaultValue?: string;
}
export default function ReactSelect({
  options,
  placeholder,
  onChange,
  label,
  name,
  onInputChange,
  isLoading,
  defaultValue,
}: IReactSelectProps) {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const customStyles: StylesConfig = {
    control: (provided, _) => ({
      ...provided,
      border: "1px solid #A1A3A2",
      borderRadius: "10px",
      background: "#fff",
      color: "#303131",
      boxShadow: "none",
      textTransform: "capitalize",
      fontSize: "16px",
      minHeight: isMobile ? "56px" : "60px",
      fontWeight: "400",
      paddingRight: "9px",

      "::placeholder": {
        fontWeight: "400",
        color: "red",
      },

      "&:hover": {
        border: "1px solid #2b9681",
        transition: "border 500ms ease-in-out",
        background: "#E2E8F0",
      },
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#F2F2F2" : "#fff",
      color: "#303131",
      textTransform: "capitalize",
      fontWeight: state.isSelected ? "500" : "400",
      fontSize: "16px",

      "&:hover": {
        background: "#F2F2F2",
        color: "#303131",
        borderRadius: "2px",
        fontWeight: "600",
        transition: "color .5s ease-in",
      },

      "::placeholder": {
        fontWeight: "400",
        color: "#A1A3A2",
      },

      "&:focus": {
        borderWidth: "1.4px",
      },
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#A1A3A2",
      fontFamily: "var(--bitmama-fonts-body)",
    }),
  };

  return (
    <Box>
      {label && <InputLabel htmlFor={name ?? ""}>{label}</InputLabel>}

      <Select
        onChange={onChange}
        options={options}
        isSearchable
        styles={customStyles}
        placeholder={placeholder}
        name={name}
        isLoading={isLoading}
        onInputChange={onInputChange}
        defaultValue={defaultValue}
        components={{ DropdownIndicator: DropdownIcon }}
      />
    </Box>
  );
}
